/* Fredesigner VO display rules (2026-10-22).
   Reads bcpo_data.fd_rules ({rules:[{t, v?, w}], labels, layout}) and hides VO options or greys out
   single values while their expression w is false. A hidden option counts as unanswered, matching the
   Neutral option sets these products copy. labels restore the visible title of renamed duplicates;
   layout slots options into the theme's Roman order. */
(function () {
  'use strict';
  if (window.FDVoRules) return;
  var data = window.__fdVoFullData || window.bcpo_data;
  var spec = data && data.fd_rules;
  if (!spec || !Array.isArray(spec.rules) || !spec.rules.length) return;

  var SEP = '\u0001';
  var optionRules = {};
  var valueRules = {};
  var preselect = {};
  (data.virtual_options || []).forEach(function (option) {
    if (option && option.unique && option.preselect_value) preselect[option.unique] = option.preselect_value;
  });
  spec.rules.forEach(function (rule) {
    if (!rule || !rule.t) return;
    var bucket = rule.v == null ? optionRules : valueRules;
    var key = rule.v == null ? rule.t : rule.t + SEP + rule.v;
    (bucket[key] = bucket[key] || []).push(rule);
  });

  var style = document.createElement('style');
  style.textContent = '.fd-rule-value-off{opacity:.35;pointer-events:none;filter:grayscale(1)}' +
    '.fd-rule-value-off label,.fd-rule-value-off+label{text-decoration:line-through}';
  document.head.appendChild(style);

  var busy = false;
  var timer = null;

  function wrappers(unique) {
    return Array.prototype.slice.call(document.querySelectorAll('.selector-wrapper[data-unique="' + unique + '"]'));
  }

  function hiddenByRule(wrap) {
    return wrap.getAttribute('data-fd-rule-hidden') === '1';
  }

  function currentValue(unique) {
    var list = wrappers(unique);
    for (var i = 0; i < list.length; i += 1) {
      var wrap = list[i];
      if (hiddenByRule(wrap)) continue;
      var radio = wrap.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
      if (radio && !radio.disabled) return radio.value;
      var select = wrap.querySelector('select');
      if (select && !select.disabled && select.value) return select.value;
    }
    return '';
  }

  /* Expression: [unique, [values]] = option currently set to one of the values;
     {o:[...]} any, {a:[...]} all, {n:x} not, true/false constants. */
  function ev(x) {
    if (x === true || x === false) return x;
    if (Array.isArray(x)) {
      var value = currentValue(x[0]);
      return !!value && x[1].indexOf(value) !== -1;
    }
    if (x && x.o) return x.o.some(ev);
    if (x && x.a) return x.a.every(ev);
    if (x && 'n' in x) return !ev(x.n);
    return true;
  }

  function wanted(list) {
    return list.every(function (rule) { return ev(rule.w); });
  }

  function applyLabels() {
    var labels = spec.labels || {};
    Object.keys(labels).forEach(function (unique) {
      wrappers(unique).forEach(function (wrap) {
        var title = wrap.querySelector('.bcpo-title');
        if (title && title.textContent !== labels[unique] + ':') title.textContent = labels[unique] + ':';
        wrap.setAttribute('aria-label', labels[unique] + ':');
      });
    });
  }

  /* layout: {unique: {order, grid}} slots options the theme's Roman CSS order table does not list. */
  function applyLayout() {
    var layout = spec.layout || {};
    Object.keys(layout).forEach(function (unique) {
      wrappers(unique).forEach(function (wrap) {
        if (layout[unique].order != null) wrap.style.setProperty('order', String(layout[unique].order), 'important');
        if (layout[unique].grid) wrap.style.setProperty('grid-column', layout[unique].grid, 'important');
      });
    });
  }

  /* VO marks only the first radio of a required group; keep that mark on the first selectable value. */
  function syncRequired() {
    (data.virtual_options || []).forEach(function (option) {
      if (!option || option.required !== 'on') return;
      wrappers(option.unique).forEach(function (wrap) {
        if (hiddenByRule(wrap)) return;
        var radios = Array.prototype.slice.call(wrap.querySelectorAll('input[type="radio"]'));
        if (!radios.length) return;
        var first = radios.filter(function (r) { return !r.disabled; })[0];
        radios.forEach(function (r) { r.required = r === first; });
      });
    });
  }

  function fire(el) {
    busy = true;
    try { el.dispatchEvent(new Event('change', { bubbles: true })); } finally { busy = false; }
  }

  function valueEnabled(unique, value) {
    var list = valueRules[unique + SEP + value];
    return list ? wanted(list) : true;
  }

  function setOption(unique, visible) {
    var changed = false;
    wrappers(unique).forEach(function (wrap) {
      if (visible === !hiddenByRule(wrap)) return;
      changed = true;
      var fields = wrap.querySelectorAll('input, select, textarea');
      if (visible) {
        wrap.removeAttribute('data-fd-rule-hidden');
        wrap.style.removeProperty('display');
        Array.prototype.forEach.call(fields, function (f) {
          f.disabled = (f.type === 'radio' || f.type === 'checkbox') ? !valueEnabled(unique, f.value) : false;
        });
        var pre = preselect[unique];
        if (pre && !wrap.querySelector('input:checked')) {
          var target = Array.prototype.filter.call(wrap.querySelectorAll('input[type="radio"]'), function (f) {
            return f.value === pre && !f.disabled;
          })[0];
          if (target) { target.checked = true; fire(target); }
        }
      } else {
        wrap.setAttribute('data-fd-rule-hidden', '1');
        wrap.style.setProperty('display', 'none', 'important');
        var uncheck = false;
        Array.prototype.forEach.call(fields, function (f) {
          if ((f.type === 'radio' || f.type === 'checkbox') && f.checked) { f.checked = false; uncheck = f; }
          if (f.tagName === 'SELECT' && f.value) { f.value = ''; uncheck = f; }
          f.disabled = true;
        });
        if (uncheck) fire(uncheck);
      }
    });
    return changed;
  }

  function setValues(unique) {
    var changed = false;
    wrappers(unique).forEach(function (wrap) {
      if (hiddenByRule(wrap)) return;
      Array.prototype.forEach.call(wrap.querySelectorAll('input[type="radio"], input[type="checkbox"]'), function (input) {
        var key = unique + SEP + input.value;
        if (!valueRules[key]) return;
        var on = wanted(valueRules[key]);
        var holder = input.closest('.bcpo-image-parent, .bcpo-button-parent') || input.parentElement;
        if (holder) holder.classList.toggle('fd-rule-value-off', !on);
        if (on === !input.disabled) return;
        changed = true;
        input.disabled = !on;
        if (!on && input.checked) { input.checked = false; fire(input); }
      });
      Array.prototype.forEach.call(wrap.querySelectorAll('select'), function (select) {
        Array.prototype.forEach.call(select.options, function (opt) {
          var key = unique + SEP + opt.value;
          if (!opt.value || !valueRules[key]) return;
          var on = wanted(valueRules[key]);
          if (on === !opt.disabled) return;
          changed = true;
          opt.disabled = !on;
          if (!on && opt.selected) { select.value = ''; fire(select); }
        });
      });
    });
    return changed;
  }

  function evaluate() {
    if (!document.querySelector('.selector-wrapper[data-unique]')) return false;
    var uniques = {};
    Object.keys(optionRules).forEach(function (u) { uniques[u] = true; });
    Object.keys(valueRules).forEach(function (k) { uniques[k.split(SEP)[0]] = true; });
    for (var pass = 0; pass < 8; pass += 1) {
      var changed = false;
      Object.keys(optionRules).forEach(function (u) {
        if (setOption(u, wanted(optionRules[u]))) changed = true;
      });
      Object.keys(uniques).forEach(function (u) {
        if (setValues(u)) changed = true;
      });
      if (!changed) break;
    }
    applyLabels();
    applyLayout();
    syncRequired();
    document.documentElement.setAttribute('data-fd-vo-rules', 'ready');
    return true;
  }

  function schedule() {
    if (busy) return;
    clearTimeout(timer);
    timer = setTimeout(evaluate, 30);
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('.selector-wrapper[data-unique]')) schedule();
  }, true);
  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('.selector-wrapper[data-unique]')) schedule();
  }, true);

  var tries = 0;
  (function boot() {
    if (evaluate()) {
      var root = document.querySelector('.selector-wrapper[data-unique]');
      var form = root && root.closest('form');
      if (form && window.MutationObserver) {
        new MutationObserver(function () { schedule(); }).observe(form, { childList: true, subtree: true });
      }
      return;
    }
    if ((tries += 1) < 100) setTimeout(boot, 100);
  })();

  window.FDVoRules = { evaluate: evaluate, rules: spec.rules, source: spec.src };
})();
